import StaticClient from './staticClient';
export default StaticClient;
